module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/WarrantyTable-ad4dabcac82f0a57cc3ee3db3d5cfff8.png";